import {
  Container,
  Stack,
  Typography,
  Button,
  Divider,
  Grid,
  FormControlLabel,
  Switch,
  Checkbox,
  Link,
  CircularProgress,
} from "@common-ui/ui";

const ViewProfilePage = ({
  isLoading,
  userEmail,
  userData,
  setMode,
  setRefreshData,
  defaultOrg,
}) => {
  return (
    <>
      {isLoading ? (
        <Stack alignItems="center" sx={{ py: 1 }}>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <Container maxWidth="md" component="main">
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="h3">My Information</Typography>
              <Button
                color="primary"
                disabled={isLoading}
                size="large"
                variant="contained"
                onClick={() => {
                  setMode("edit");
                  setRefreshData(false);
                }}
                component="span"
              >
                Edit
              </Button>
            </Stack>
            <Divider sx={{ py: 1 }} />
          </Container>
          <Container maxWidth="md" component="main" sx={{ mt: 3 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ my: 3 }}
            >
              <Typography variant="h4">Full Name</Typography>
              <FormControlLabel
                control={<Switch />}
                label="Private"
                name="name_private"
                disabled
                value={userData?.name_private}
                checked={userData?.name_private}
              />
            </Stack>
            <Stack direction="row" spacing={2} justifyContent="space-between">
            
              <Typography variant="h5" style={{ fontWeight: "normal" }}>{`${
                userData?.salutation ?? ""
              } ${userData?.first_name ?? ""} ${userData?.middle_initial ?? ""} ${
                userData?.last_name ?? ""
              }`}</Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ my: 3 }}
            >
              <Typography variant="h4">Organization</Typography>
            </Stack>
            <Stack direction="row" spacing={2} justifyContent="space-between">
              <Typography
                variant="h5"
                style={{ fontWeight: "normal" }}
              >{`${defaultOrg} `}</Typography>
            </Stack>
            <Divider sx={{ py: 1 }} />
          </Container>
          <Container maxWidth="md" component="main" sx={{ mt: 3 }}>
            <Typography variant="h4" sx={{ my: 3 }}>
              Contact Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                {" "}
                <div>
                  <Typography variant="h6" style={{ fontWeight: "normal" }}>
                    Email
                  </Typography>
                  <Typography variant="h5" style={{ fontWeight: "normal" }}>
                    {userEmail ?? "--"}
                  </Typography>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                {" "}
                <div>
                  <Typography variant="h6" style={{ fontWeight: "normal" }}>
                    Website
                  </Typography>
                  <Link
                    href={userData?.webpage?.trim()}
                    target="_blank"
                    style={{
                      textDecoration: `${
                        userData?.webpage?.trim() ? "inherit" : "none"
                      }`,
                      //   color: `${userData?.website ? "#006faa" : "#000000"}`,
                    }}
                  >
                    <Typography
                      variant="h5"
                      style={{
                        fontWeight: "normal",
                      }}
                    >
                      {userData?.webpage?.trim()
                        ? userData?.webpage?.trim()
                        : "--"}
                    </Typography>
                  </Link>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                {" "}
                <div>
                  <Typography variant="h6" style={{ fontWeight: "normal" }}>
                    Display Name
                  </Typography>
                  <Typography variant="h5" style={{ fontWeight: "normal" }}>
                    {userData?.display_name?.trim() ? userData?.display_name?.trim() : "--"}
                  </Typography>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                {" "}
                <div>
                  <Typography variant="h6" style={{ fontWeight: "normal" }}>
                    LinkedIn
                  </Typography>
                  <Link
                    href={userData?.linkedin?.trim()}
                    target="_blank"
                    style={{
                      textDecoration: `${
                        userData?.linkedin?.trim() ? "inherit" : "none"
                      }`,
                      //   color: `${userData?.website ? "#006faa" : "#000000"}`,
                    }}
                  >
                    <Typography
                      variant="h5"
                      style={{
                        fontWeight: "normal",
                      }}
                    >
                      {userData?.linkedin?.trim()
                        ? userData?.linkedin?.trim()
                        : "--"}
                    </Typography>
                  </Link>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                {" "}
                <div>
                  <Typography variant="h6" style={{ fontWeight: "normal" }}>
                    Recovery Email
                  </Typography>
                  <Typography variant="h5" style={{ fontWeight: "normal" }}>
                    {userData?.recovery_email?.trim()
                      ? userData?.recovery_email?.trim()
                      : "--"}
                  </Typography>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                {" "}
                <div>
                  <Typography variant="h6" style={{ fontWeight: "normal" }}>
                    Facebook
                  </Typography>
                  <Link
                    href={userData?.facebook?.trim()}
                    target="_blank"
                    style={{
                      textDecoration: `${
                        userData?.facebook?.trim() ? "inherit" : "none"
                      }`,
                      //   color: `${userData?.website ? "#006faa" : "#000000"}`,
                    }}
                  >
                    <Typography
                      variant="h5"
                      style={{
                        fontWeight: "normal",
                      }}
                    >
                      {userData?.facebook?.trim()
                        ? userData?.facebook?.trim()
                        : "--"}
                    </Typography>
                  </Link>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                {" "}
                <div>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="h6" style={{ fontWeight: "normal" }}>
                      Office Phone
                    </Typography>
                    <FormControlLabel
                      control={<Switch />}
                      label="Private"
                      name="office_phone_private"
                      disabled
                      value={userData?.office_phone_private}
                      checked={userData?.office_phone_private}
                    />
                  </Stack>
                  <Typography variant="h5" style={{ fontWeight: "normal" }}>
                    {userData?.office_phone?.trim()
                      ? userData?.office_phone
                      : "--"}
                  </Typography>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                {" "}
                <div>
                  <Typography variant="h6" style={{ fontWeight: "normal" }}>
                    Twitter
                  </Typography>
                  <Link
                    href={userData?.twitter?.trim()}
                    target="_blank"
                    style={{
                      textDecoration: `${
                        userData?.twitter?.trim() ? "inherit" : "none"
                      }`,
                      //   color: `${userData?.website ? "#006faa" : "#000000"}`,
                    }}
                  >
                    <Typography
                      variant="h5"
                      style={{
                        fontWeight: "normal",
                      }}
                    >
                      {userData?.twitter?.trim()
                        ? userData?.twitter?.trim()
                        : "--"}
                    </Typography>
                  </Link>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                {" "}
                <div>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="h6" style={{ fontWeight: "normal" }}>
                      Mobile
                    </Typography>
                    <FormControlLabel
                      control={<Switch />}
                      label="Private"
                      name="mobile_phone_private"
                      disabled
                      value={userData?.mobile_phone_private}
                      checked={userData?.mobile_phone_private}
                    />
                  </Stack>
                  <Typography variant="h5" style={{ fontWeight: "normal" }}>
                    {userData?.mobile_phone?.trim()
                      ? userData?.mobile_phone
                      : "--"}
                  </Typography>
                </div>
              </Grid>
            </Grid>
            <Divider sx={{ py: 1 }} />
          </Container>
          <Container maxWidth="md" component="main" sx={{ mt: 3 }}>
            <Typography variant="h4" sx={{ my: 3 }}>
              Addresses
            </Typography>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h5">Mailing Address</Typography>
                  <FormControlLabel
                    control={<Switch />}
                    label="Private"
                    name="mailing_address_private"
                    disabled
                    value={userData?.mailing_address_private}
                    checked={userData?.mailing_address_private}
                  />
                </Stack>
                <Stack direction="column">
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      Address 1
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.mailing_address?.address_line_1 ?? "--"}
                    </Typography>
                  </div>
                  <Typography variant="h6" sx={{ mt: 1, fontWeight: "normal" }}>
                    Address 2
                  </Typography>
                  <Typography variant="h5" style={{ fontWeight: "normal" }}>
                    {userData?.mailing_address?.address_line_2
                      ? userData?.mailing_address?.address_line_2
                      : "--"}
                  </Typography>
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      City
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.mailing_address?.city ?? "--"}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      State/Province
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.mailing_address?.state_or_province ?? "--"}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      Country / Region
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.mailing_address?.country_or_region ?? "--"}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      Zip/Postal Code
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.mailing_address?.postal_code ?? "--"}
                    </Typography>
                  </div>
                </Stack>
                {/* </Container> */}
                {/* </Grid> */}
              </Grid>
              <Grid item md={6} xs={12}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h5">Shipping Address</Typography>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Same as Mailing address"
                      name="shipping_same_as_mailing"
                      disabled
                      value={userData?.shipping_same_as_mailing}
                      checked={userData?.shipping_same_as_mailing}
                      sx={{ mr: 0.5 }}
                    />
                    <FormControlLabel
                      control={<Switch />}
                      label="Private"
                      name="shipping_address_private"
                      disabled
                      value={userData?.shipping_address_private}
                      checked={userData?.shipping_address_private}
                    />
                  </Stack>
                </Stack>
                <Stack direction="column">
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      Address 1
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.shipping_address?.address_line_1 ?? "--"}
                    </Typography>
                  </div>
                  {/* </Container> */}
                  {/* <Container> */}
                  <Typography variant="h6" sx={{ mt: 1, fontWeight: "normal" }}>
                    Address 2
                  </Typography>
                  <Typography variant="h5" style={{ fontWeight: "normal" }}>
                    {userData?.shipping_address?.address_line_2
                      ? userData?.shipping_address?.address_line_2
                      : "--"}
                  </Typography>
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      City
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.shipping_address?.city ?? "--"}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      State/Province
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.shipping_address?.state_or_province ?? "--"}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      Country / Region
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.shipping_address?.country_or_region ?? "--"}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      variant="h6"
                      sx={{ mt: 1, fontWeight: "normal" }}
                    >
                      Zip/Postal Code
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: "normal" }}>
                      {userData?.shipping_address?.postal_code ?? "--"}
                    </Typography>
                  </div>
                </Stack>
              </Grid>
            </Grid>
            <Divider sx={{ py: 1 }} />
          </Container>
          <Container maxWidth="md" component="main">
            <Typography variant="h4" sx={{ my: 3 }}>
              Notification Settings
            </Typography>
            <Stack direction="column">
              <Typography variant="h6" sx={{ mt: 1, fontWeight: "normal" }}>
                Receive email communications
              </Typography>
              <Typography variant="h5" style={{ fontWeight: "normal" }}>
                {userData?.email_notification
                  ? "Yes (Opted-in)"
                  : "No (Opted-out)"}
              </Typography>

              <Typography variant="h6" sx={{ mt: 1, fontWeight: "normal" }}>
                Receive SMS text communications
              </Typography>
              <Typography variant="h5" style={{ fontWeight: "normal" }}>
                {userData?.mobile_phone_sms_notification
                  ? "Yes (Opted-in)"
                  : "No (Opted-out)"}
              </Typography>
            </Stack>
          </Container>
        </>
      )}
    </>
  );
};

export default ViewProfilePage;
